import type { ClientApi } from '../../../../api';
import Helper from '../../../models/Helper';

const URI = '/offers';

/**
 * @desc Helper for offers.
 */

class OffersHelper extends Helper {
  constructor(api: ClientApi) {
    super(api, URI);
  }
}

export default OffersHelper;
